import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import Select from 'react-select';

class ShortNameTrainingsTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      trainings: [],
    };
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.trainings)) {
      this.setState({trainings: newProps.trainings});
    }
  }  

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Lista de nomes curtos de treinamentos</h3>
  <hr/>
  <BootstrapTable data={this.state.trainings} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há nomes curtos para treinamentos cadastrados', sizePerPage: 100, defaultSortName: 'short_name', defaultSortOrder: 'ASC'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

    <TableHeaderColumn dataField="short_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome Curto</TableHeaderColumn>

    <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome Completo</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default ShortNameTrainingsTab;



// WEBPACK FOOTER //
// ./src/Components/Configuracoes/Elements/ShortNameTrainingsTab.js